export function DashboardRightSidebar() {
  return (
    // Size from the image's own 2:3 ratio (capped to the viewport) so it never crops on wide screens.
    <div className="flex min-h-0 justify-center">
      <img
        src="/healthsource-ad.img"
        alt="HealthSource"
        width={1024}
        height={1536}
        className="block h-auto max-h-[calc(100vh-8rem)] w-auto max-w-full rounded-lg"
      />
    </div>
  );
}
